(() => {
  const customizerOrigin = "https://customizer.coozebra.com";
  document.querySelectorAll("[data-coozebra-cart-preview]").forEach(async node => {
    const designId = node.dataset.designId;
    const configurationReference = node.dataset.configurationReference;
    const previewUrl = (fallback = false) => {
      const url = new URL(`${customizerOrigin}/customizer/api/designs/${encodeURIComponent(designId)}/cart-preview`);
      url.searchParams.set("color", node.dataset.color || "");
      url.searchParams.set("token", configurationReference);
      if (fallback) url.searchParams.set("fallback", "base");
      return url;
    };
    const showBaseGarment = async () => {
      const response = await fetch(previewUrl(true), { mode: "cors", credentials: "omit" });
      if (!response.ok) throw new Error("base garment unavailable");
      const image = new Image();
      image.alt = node.dataset.fallbackAlt || "Selected product";
      image.src = URL.createObjectURL(await response.blob());
      node.replaceChildren(image);
    };
    if (!designId || !configurationReference) {
      node.hidden = true;
      return;
    }
    try {
      // Show the same selected-color garment while the frozen design preview loads.
      await showBaseGarment();
      const response = await fetch(previewUrl(), { mode: "cors", credentials: "omit" });
      if (!response.ok) throw new Error("preview unavailable");
      const image = new Image();
      image.alt = "Your custom design preview";
      image.src = URL.createObjectURL(await response.blob());
      node.replaceChildren(image);
      node.classList.remove("is-loading");
      node.setAttribute("aria-busy", "false");
    } catch {
      node.replaceChildren(Object.assign(document.createElement("span"), { textContent: "Your design preview is unavailable." }));
      node.classList.remove("is-loading");
      node.setAttribute("aria-busy", "false");
    }
  });
})();
